// src/config.js
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Who runs this app and how to reach them: shown in the privacy policy, the terms and the help page. Set them in
// .env.production (REACT_APP_OPERATOR_NAME, REACT_APP_CONTACT_EMAIL); without them the texts say so instead of inventing any.
export const OPERATOR_NAME = process.env.REACT_APP_OPERATOR_NAME || '';
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || '';
